import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

type ExportExcelProps = {
    onClick: () => void;
};

const ExportExcel = ({ onClick }: ExportExcelProps) => {
    const { t } = useTranslation(['financeProductDetails']);

    return (
        <Button key="export" onClick={onClick} size="middle" type="primary">
            {t('financeProductDetails:actions.exportExcel')}
        </Button>
    );
};

export default ExportExcel;
